const Switch = {
  baseStyle: {
    track: {
      w: '44px',
      py: '4px',
      px: '4px',
    },
    thumb: {
      _checked: {
        transform: `translateX(28px)`,
      },
    },
  },
}

export default Switch
